<template>
  <div class="account">
    <Navbar :title="`账号管理`"></Navbar>
    <div class="list">
      <div class="item" v-for="(item,index) in list" :key="index" @click="onLogin(item)">
        <img :src="item.avatar" alt="" />
        <span class="name">{{item.nickname}}</span>
        <van-icon v-if="userInfo.id == item.be_uid" class="icon" name="success" />
      </div>
      <router-link to="/accountAdd" class="item">
        <div class="add">
          <van-icon name="plus" size="20px" color="#999" />
        </div>
        <span class="name">添加账号</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import Tabber from "../components/Tabber";
import Navbar from "../components/Navbar";
import {
  indexOp,
  updateOp,
  deleteOp,
  addOp,
  showOp,
  uploadImg,
  uploadFile,
} from "../api/index";
import base from "../api/base";
export default {
  props: {},
  data() {
    return {
      userInfo: "",
      list:""
    };
  },
  computed: {},
  created() {
    this.userInfo = this.$cookies.get("userInfo");
    this.getList();
  },
  mounted() {},
  watch: {},
  methods: {
    getList() {
      var _this = this;
      var login_type = this.$cookies.get("login_type");
      console.log(login_type)
      var data = {
        uid: this.userInfo.id
      };
      if(login_type){
        data.login_type = login_type;
      }else{
        data.login_type = 1;
      }
      indexOp("/login_log/index",data).then((res) => {
        if (res && res.status == 200) {
          _this.list = res.data
          console.log(res);
        }
      });
    },
    onLogin(info){
      var _this = this;
      var data = {
        mobile:info.mobile,
        uid:info.be_uid,
        parent_uid:info.uid
      }
      addOp("/oauth/fast_login",data).then(res=>{
        if(res && res.status == 200){
          _this.$toast.success("登录成功！");
          _this.$cookies.set("Authorization",res.data.token_type + " " + res.data.access_token)
          _this.$cookies.set("login_type", res.data.login_type);
          setTimeout(() => {
            _this.$router.push("/user")
          }, 800);
        }
        console.log(res)
      })
    },
  },
  components: {
    Tabber,
    Navbar,
  },
};
</script>

<style scoped >
</style>
